// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-wrapper .user-info-subcontainer {
    display: flex !important;
    flex-direction: column !important;
}

.notification-wrapper-box {
    width: 100% !important;
    margin-bottom: 10px;
    padding: 0px !important;
    transition: all ease-in-out 5;
    position: relative;
    display: flex;
    justify-content: space-between;
}

.message-wrapper {
    width: 100%;
    padding: 15px 25px !important;
}

.notification-wrapper-box p {
    font-size: 14px !important;
    margin-bottom: 13px;
    margin-right: 20px;
    width: calc(100% - 60px);
    color: var(--dark-purple);
    font-family: var(--inter-Medium500);
    line-height: 26px;
    letter-spacing: -0.32px;
    white-space: pre-wrap;
}

.notification-wrapper-box p:nth-child(2) {
    font-size: 12px !important;
    color: var(--text-color);
}

.notification-wrapper-box .delete-but-container {
    width: 60px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    display: flex;
    justify-content: center;

    cursor: pointer;
}

.notification-wrapper-box img {
    width: 14px;
    height: 14px;
    mix-blend-mode: multiply;
    margin-top: 22px;
}

.notification-wrapper-box .delete-but-container:hover,
.notification-wrapper-box p:hover {
    opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/screens/common/notificationPage/NotificationPage.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,mCAAmC;IACnC,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,gCAAgC;IAChC,aAAa;IACb,uBAAuB;;IAEvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB","sourcesContent":[".notification-wrapper .user-info-subcontainer {\n    display: flex !important;\n    flex-direction: column !important;\n}\n\n.notification-wrapper-box {\n    width: 100% !important;\n    margin-bottom: 10px;\n    padding: 0px !important;\n    transition: all ease-in-out 5;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n}\n\n.message-wrapper {\n    width: 100%;\n    padding: 15px 25px !important;\n}\n\n.notification-wrapper-box p {\n    font-size: 14px !important;\n    margin-bottom: 13px;\n    margin-right: 20px;\n    width: calc(100% - 60px);\n    color: var(--dark-purple);\n    font-family: var(--inter-Medium500);\n    line-height: 26px;\n    letter-spacing: -0.32px;\n    white-space: pre-wrap;\n}\n\n.notification-wrapper-box p:nth-child(2) {\n    font-size: 12px !important;\n    color: var(--text-color);\n}\n\n.notification-wrapper-box .delete-but-container {\n    width: 60px;\n    border-top-right-radius: 15px;\n    border-bottom-right-radius: 15px;\n    display: flex;\n    justify-content: center;\n\n    cursor: pointer;\n}\n\n.notification-wrapper-box img {\n    width: 14px;\n    height: 14px;\n    mix-blend-mode: multiply;\n    margin-top: 22px;\n}\n\n.notification-wrapper-box .delete-but-container:hover,\n.notification-wrapper-box p:hover {\n    opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
